import { render, staticRenderFns } from "./edit-certificate.vue?vue&type=template&id=60ebb080&scoped=true&"
import script from "./edit-certificate.vue?vue&type=script&lang=js&"
export * from "./edit-certificate.vue?vue&type=script&lang=js&"
import style0 from "./edit-certificate.vue?vue&type=style&index=0&id=60ebb080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ebb080",
  null
  
)

export default component.exports